<template>
  <div id="app">
    <!-- 侧边栏，头部展示 -->
    <navigation @fun_is="fun" v-if="nav_hide"></navigation>
    <!-- 内容展示 -->
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
import "@/iconfont/iconfont.css";
import navigation from "@/components/navigation_bar/navigation_bar";
// import router from './router'

export default {
  name: "layout",
  components: { navigation },

  methods: {},
  data() {
    return {
      nav_hide: true,
      includes: [],
      is_hide: this.$route.meta.menu,
    };
  },
  created() {},
  updated(e) {},
  methods: {
    fun() {
      this.nav_hide = false;
      this.$nextTick(() => {
        this.nav_hide = true;
      });
    },
  },
  watch: {},
};
</script>




// WEBPACK FOOTER //
// src/layout/index.vue